export const environment = {
	production: true,
	observabilityEnabled: true,
	noAuth: false,
	openReplayIngestPoint: '/replay'
};
